import React from 'react';
import { SectionWrapper } from './ui/SectionWrapper';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
export function MoreParents() {
  const moreParents = [{
    quote: 'Me dio herramientas concretas, no solo teoría.',
    author: 'Fernando L.',
    role: 'Padre preocupado'
  }, {
    quote: 'Por fin entendí cómo proteger a mi hija sin pelear con ella.',
    author: 'Mariana T.',
    role: 'Mamá de adolescente'
  }, {
    quote: 'Lo apliqué el mismo día. Ahora duermo más tranquilo.',
    author: 'Gustavo A.',
    role: 'Papá de 3 hijos'
  }];
  return <SectionWrapper className="bg-[#0a2c47] border-y border-sky-900/40 text-center px-0 md:px-4" data-id="element-109">
      <h2 className="text-2xl md:text-4xl font-extrabold mb-2 md:mb-3 text-white px-4 md:px-0" data-id="element-110">
        MÁS PADRES YA LO TIENEN
      </h2>
      <p className="text-sm md:text-lg text-slate-300 mb-6 md:mb-10 px-4 md:px-0" data-id="element-111">
        Cada día más familias toman el control de su mundo digital.
      </p>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4 max-w-4xl mx-auto px-4 md:px-0" data-id="element-112">
        {moreParents.map((t, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: i * 0.08
      }} className="bg-[#0d3354] shadow-md rounded-xl p-4 md:p-5 text-left flex flex-col relative border border-sky-900/40" data-id="element-113">
            <div className="flex gap-0.5 mb-2.5" data-id="element-114">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-3.5 h-3.5 fill-yellow-400 text-yellow-400" data-id="element-115" />)}
            </div>
            <p className="text-sm md:text-[15px] italic text-slate-300 font-medium leading-relaxed mb-3" data-id="element-116">
              "{t.quote}"
            </p>
            <div className="flex flex-col items-start w-full mt-auto pt-2.5 border-t border-sky-900/40" data-id="element-117">
              <p className="font-bold text-white text-sm" data-id="element-118">{t.author}</p>
              <p className="text-xs text-slate-400" data-id="element-119">{t.role}</p>
            </div>
          </motion.div>)}
      </div>
    </SectionWrapper>;
}